import React from "react";
import { Layout, TextField, Text } from "@shopify/polaris";

const JsonMetaData = (props) => {
  const { inputValue, handleChange, metafield } = props;

  return (
    <>
      <Text as="span" variant="bodySm">{`${metafield.name} ${metafield.isRequired ? "*" : ""}`}</Text>
      <TextField
        value={inputValue[metafield.key] || ""}
        onChange={(value) => handleChange(metafield.key, value, "", "", metafield.contentType)}
        multiline={4}
      />
      <Layout.Section />
    </>
  );
};

export default JsonMetaData;
